
export class SaveToCloudRequestModel {
    public layoutXml: string | null = null;
    public icon: string | null = null;
    public clearPreviousLayout = false;
    public fillScreen = false;
    public shortDescription: string | null = null;
    public longDescription: string | null = null;
}